import { TipoStatusNotificacaoEnum } from "../enums/tipo-status-notificacao-enum";
import { Util } from "../util/util";
import { LoteNotificacaoSms } from "./lote-notificacao-sms";
import { NotificacaoSmsPK } from "./pks/notificacao-sms-pk";

export class NotificacaoSms {

    pk: NotificacaoSmsPK = new NotificacaoSmsPK();

    tipoStatusNotificacao: TipoStatusNotificacaoEnum = TipoStatusNotificacaoEnum.SUC;

    loteNotificacaoSms: LoteNotificacaoSms = new LoteNotificacaoSms();

    nomePessoaNotificacao: string = '';

    constructor() {
    }

    getIconeTipoStatusNotificacao(): string {

        return Util.getIconeTipoStatusNotificacao(this.tipoStatusNotificacao);
    }

    getCorTipoStatusNotificacao(): string {

        return Util.getCorTipoStatusNotificacao(this.tipoStatusNotificacao);
    }

    getTooltipTipoStatusNotificacao(): string {

        return Util.getTooltipTipoStatusNotificacao(this.tipoStatusNotificacao);
    }
}
